import { formatSeconds, toMoney } from "../../Components/Functions";
import { UPDATE } from "./types";

const INITIAL_STATE = {
	upcoming: {
		name: "Amanda Illiay",
		role: "SPECIALIST",
		image: "https://huro.cssninja.io/assets/img/avatars/photos/13.jpg",
		background_image: "https://images.pexels.com/photos/6457556/pexels-photo-6457556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed fac ista esse non inportuna. ",
		status: "",
		data : [
			{
				icon: "calendar",
				value: "12 Dec. 2021",
				label: "Date"
			},
			{
				icon: "clock",
				value: "13:00pm - 14:00pm",
				label: "Time"
			},
			{
				icon: "clock",
				value: formatSeconds(90),
				label: "Duration"
			},
			{
				icon: "credit-card",
				value: toMoney(6500),
				label: `Fee • <span style="color: #fff;line-height: 1.65;height: 20px;" class="tag is-danger is-elevated">Unpaid</span>`    
			}
		]
	}
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};


